import { makeActionCreator } from '../../../config/store/utils';
import { readParquet } from '../../../services/productivityService'; // Assuming the function is in this service file

// Action Types
export const GET_CYCLEWALL_REPORT = 'GET_CYCLEWALL_REPORT';
export const GET_CYCLEWALL_REPORT_ERROR = 'GET_CYCLEWALL_REPORT_ERROR';
export const GET_CYCLEWALL_REPORT_SUCCESS = 'GET_CYCLEWALL_REPORT_SUCCESS';

// Action Creators
export const onGetCycleWallReport = makeActionCreator(GET_CYCLEWALL_REPORT);
export const onGetCycleWallReportError = makeActionCreator(
  GET_CYCLEWALL_REPORT_ERROR,
  'payload'
);
export const onGetCycleWallReportSuccess = makeActionCreator(
  GET_CYCLEWALL_REPORT_SUCCESS,
  'payload'
);

// Async action to fetch the Parquet data
export const onGetCycleWallReportThunk = ({
  year,
  month,
  day,
}) => async dispatch => {
  dispatch(onGetCycleWallReport()); // Start loading
  try {
    const type = 'ciclos_intra_muros_v2';
    const response = await readParquet({ type, year, month, day });
    const data = JSON.parse(response.data).map((item, index) => {
      return {
        ...item,
        id: `${index + 1}`,
      };
    });
    dispatch(onGetCycleWallReportSuccess({ data: data })); // Dispatch success with the data
  } catch (error) {
    dispatch(
      onGetCycleWallReportError({
        error: error.message || 'Error fetching data',
      })
    ); // Dispatch error
  }
};
